import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const FormGroup = ({
  name,
  label,
  handleChange,
  submitAttempt,
  value,
  type,
  required,
  whiteBg
}) => {
  const [focused, setFocused] = useState(false);
  const handleFocus = val => () => {
    setFocused(val);
  };
  const empty = useCallback(() => {
    return !value || value.trim() === '';
  });
  const errMsg = submitAttempt && required && empty();
  return (
    <div className={`form-group  ${focused || !empty() ? 'focused' : ''} `}>
      <label
        className={`form-label ${whiteBg ? 'whiteBg' : ''}`}
        htmlFor={name}
      >
        {label}
      </label>
      {type === 'input' ? (
        <input
          name={name}
          id={name}
          onChange={handleChange(name)}
          onFocus={handleFocus(true)}
          onBlur={handleFocus(false)}
          value={value}
          className={`form-input ${!empty() && !focused ? 'filled' : ''} ${
            errMsg ? 'error' : ''
          }`}
        />
      ) : (
        <textarea
          name={name}
          id={name}
          onChange={handleChange(name)}
          onFocus={handleFocus(true)}
          onBlur={handleFocus(false)}
          value={value}
          className={`form-input ${!empty() && !focused ? 'filled' : ''} ${
            errMsg ? 'error' : ''
          }`}
        />
      )}
      {errMsg && <span className="err-msg">Error message</span>}
    </div>
  );
};

export default FormGroup;

FormGroup.defaultProps = {
  submitAttempt: false,
  type: 'input',
  required: false,
  label: ''
};

FormGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  submitAttempt: PropTypes.bool,
  type: PropTypes.oneOf(['input', 'textarea']),
  required: PropTypes.bool,
  label: PropTypes.string
};
